import { css } from "@nju/css";
import { useDecodedToken } from "@nju/data-access-sales-seller";
import { Heading } from "@nju/ui";
import { CheckClientPanel } from "./partials";
import { CheckSystemStatus, StartOrderForClient } from "./partials";
import { SalesDispositions } from "./partials";

export function PanelPage() {
  const token = useDecodedToken();

  return (
    <div>
      <Heading
        font="ttfirs"
        level="h2"
        tone="neutral"
        variant="dashboardTitle"
        weight="bold"
      >
        {token ? `cześć, ${token.name.split(" ")[0]}` : "cześć"}
      </Heading>
      <div className={styles.panels()}>
        <div className={styles.actions()}>
          <CheckClientPanel />
        </div>
        <div className="flex gap-5 mb-5 only-mobile:flex-col">
          <StartOrderForClient mode="ftth" />
          <StartOrderForClient mode="mobile" />
        </div>
        <SalesDispositions />
        <div className={styles.panels()}>
          <CheckSystemStatus />
        </div>
      </div>
    </div>
  );
}

export const styles = {
  panels: css({
    mt: "$20",
  }),
  actions: css({
    mb: "$20",
    display: "flex",
    flexDirection: "column",
    alignContent: "stretch",
    "@fromTablet": {
      flexDirection: "row",
    },
    gap: "$20",
    "> *": {
      flex: 1,
    },
    "> :nth-child(1)": {
      flex: 2,
    },
  }),
};
